module.exports = __webpack_public_path__ + "static/media/f_l_07.274c5b93.png";